export default __webpack_public_path__ + "static/media/crowfund.8af44c58.png";